<template>
  <div id="organizationSelectContainer" :class="['form-group', {'has-error': hasFieldErrors(pErrorKey)}]">
    <div v-if="hasFieldErrors(pErrorKey)">
      <span v-for="error in getFieldErrors(pErrorKey)" class="help-block" :key="error">{{ error }}</span>
    </div>
    <label v-else for="organizationSelect">
      <span v-if="pRequired" class="required">*</span> {{ pDictionary['dictionary.organization.plural'] }}:
    </label>
    <select id="organizationSelect"
            ref="organizationSelect"
            :name="pInputName"
            v-model="selectedIds"
            data-live-search="true"
            :data-container="pSelectContainer || 'false'"
            :data-deselect-all-text="pDictionary['dictionary.actions.select.none']"
            :data-select-all-text="pDictionary['dictionary.actions.select.all']"
            :data-count-selected-text="pDictionary['dictionary.organization.count']"
            :data-none-selected-text="pDictionary['dictionary.organization.select.multiple']"
            data-selected-text-format="count > 3"
            data-actions-box="true"
            class="form-control selectpicker" multiple
            :disabled="disabled">
      <optgroup v-for="organizationGroupRef in organizationRefList"
                :key="organizationGroupRef.id"
                :label="organizationGroupRef.name">
        <option v-for="organizationRef in organizationGroupRef.childDataRefs"
                :key="organizationRef.id"
                :value="organizationRef.id"
                :selected="selectedIds.includes(organizationRef.id)"
                :data-tokens="organizationGroupRef.name + ',' + organizationRef.name">
          {{ organizationRef.name }}
        </option>
      </optgroup>
    </select>
  </div>
</template>

<script>
export default {
  name: "OrganizationSelect",
  props: {
    value: Array,
    pCurrencies: Array,
    pLanguage: String,
    pDictionary: Object,
    pUrls: Object,
    pErrorList: {
      type: Object,
      default: function () {
        return {}
      }
    },
    pSrc: String,
    pSrcId: String,
    pErrorKey: String,
    pRequired: Boolean,
    pInputName: String,
    pSelectContainer: {
      default: function () {
        return ""
      }
    },
    pDisabled: Boolean,
    pDisplaySummary: Boolean
  },
  data: function () {
    return {
      organizationRefList: [],
      selectedIds: this.value
    }
  },
  methods: {
    hasFieldErrors: function (name) {
      if(name in this.pErrorList)
      {
        return !$.isEmptyObject(this.pErrorList[name]);
      }
    },
    getFieldErrors: function (name) {
      if(name in this.pErrorList)
      {
        return this.pErrorList[name];
      }
      return [];
    }
  },
  computed: {
    disabled: function () {
      return this.pDisabled || this.organizationRefList.length === 0;
    }
  },
  watch: {
    selectedIds: function() {
      this.$emit('input', this.selectedIds)
    },
    disabled: function() {
      let _component = this;
      let $organizationSelect = $(_component.$refs.organizationSelect);
      $organizationSelect.selectpicker('refresh');
    }
  },
  mounted: function () {
    let _component = this;
    let $organizationSelect = $(_component.$refs.organizationSelect);
    $organizationSelect.selectpicker();
    $organizationSelect.on('changed.bs.select', function(e, clickedIndex) {
      let $bsSelect = $(e.target);
      let $clickedOption = $bsSelect.find('option').eq(clickedIndex);
      if($clickedOption.val() <= 0) {
        $.each($bsSelect.find(":selected").not($clickedOption), function(index, option) {
          let $option = $(option);
          $option.prop('selected', false);
        });
      } else {
        $.each($bsSelect.find(":selected").not($clickedOption), function(index, option) {
          let $option = $(option);
          if($option.val() <= 0) {
            $option.prop('selected', false);
          }
        });
      }
      $bsSelect.selectpicker('refresh');
    });

    $.ajax({
             type: "POST",
             url: '/mediaplan/app/endpoints/json-api/ref/organizations',
             data: JSON.stringify({
                 groupBy: 'S-30' /* OrganizationGroupDefinition.TOKEN */
             }),
             headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
             }
           }).done(function (refList) {
      _component.organizationRefList = refList;
    });
  },
  updated: function() {
    let _component = this;
    let $organizationSelect = $(_component.$refs.organizationSelect);
    $organizationSelect.selectpicker('refresh');
  },
  destroyed: function() {
    let _component = this;
    let $organizationSelect = _component.$refs.organizationSelect;
    $organizationSelect.selectpicker('destroy');
  }
}
</script>

<style scoped>

</style>